<template>
	<div class="page-cart">
		<div class="container1">
			<div class="wrap">
				<div class="main">
					<div class="header" v-if="title">
						<div class="title" v-text="title"/>
					</div>

					<slot/>
				</div>
				<div class="side" v-if="!$res.small()">
					<div class="cart-placeholder"/>
					<cart/>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import cart from "@/components/cart-mini/index.vue";
export default {
	components: {cart},
	props: {
		title: {type: String, required: false}
	}
};
</script>

<style lang="scss" scoped>
.page-cart {
	.wrap {
		display: flex;

		.main {
			width: 100%;

			.header {
				.title {
					font-family: $fontMinion;
					font-size: 28px;
					font-weight: 700;
					margin-bottom: 2em;
				}
			}
		}

		.side {
			flex-shrink: 0;
			padding-left: em(64);
			min-height: 100vh;

			.cart-placeholder {
				width: $minicart;
			}
		}
	}
}
</style>
